import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api';
import type { DomainFlowRelationDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

export type { DomainFlowRelationDTO as FlowRelationEntry } from './types';

const getDomainFlowRelations = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<DomainFlowRelationDTO[]> => {
  const res = await apiClient.get<{ data: DomainFlowRelationDTO[] }>(queryKey[1], { signal });

  return res.data.data;
};

export const getDomainFlowRelationsOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getDomainFlowRelations,
    queryKey: [
      'getDomainFlowRelations',
      parseAdsLibraryApiPath('ad_company_branch_domain_flow_relations', params),
    ] as const,
  });
